<template>
    <div id="home">
        <div class="ribbon"></div>
        <div class="pad-top">
            <v-card class="mx-auto"
                    max-width="500">
                <v-card-title class="justify-center">Connexion</v-card-title>

                <v-container>
                    <v-text-field v-model="email" label="Email" id="email" name="email" outlined></v-text-field>
                    <v-text-field v-model="password"
                                  id="password"
                                  label="Mot de passe"
                                  class="mb-2"
                                  hide-details
                                  v-on:keyup.enter="login()"
                                  :append-icon="displayPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                  :type="displayPassword ? 'text' : 'password'"
                                  @click:append="displayPassword = !displayPassword"
                                  outlined>
                    </v-text-field>
                    <v-alert class="mb-5" color="red lighten-2" dark v-if="error">
                        {{ error }}
                    </v-alert>

                    <router-link to="/forget-password">Mot de passe oublié</router-link>

                    <div class="text-center mb-5" v-if="startSpinner">
                        <v-progress-circular indeterminate></v-progress-circular>
                    </div>

                    <div class="text-center">
                        <v-btn class="default-button mt-2" @click="login()">Se connecter</v-btn>
                        <div class="mt-4">
                            <router-link to="/">Se connecter autrement</router-link>
                        </div>
                    </div>
                </v-container>
            </v-card>

            <v-container v-if="resetPassword" style="max-width:500px" class="pl-0 pr-0 mt-4">
                <v-alert color="success" type="success">Votre mot de passe a bien été réinitialisé.</v-alert>
            </v-container>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "Login",
    data() {
        return {
            email: null,
            password: null,
            submitted: false,
            error: null,
            startSpinner: false,
            displayPassword: false,
            resetPassword: false
        }
    },
    methods: {
        async login() {
            this.submitted = true
            this.error = null
            this.startSpinner = true

            try {
                await this.$store.dispatch('account/login', [this.email, this.password])
                await this.$store.dispatch('account/getCredentials')

                if(this.user.cgu_validation) {
                    this.$router.push('/home')
                } else {
                    this.$router.push('/accept-cgu')
                }

                this.startSpinner = false

            } catch (e) {
                this.error = "Email ou mot de passe incorrect"
                this.startSpinner = false
            }
        }
    },
    computed: {
        ...mapState('account', ['user'])
    },
    created() {
        this.resetPassword = this.$route.query.resetPassword !== undefined
    }
}
</script>